import { render, staticRenderFns } from "./company-notifications.vue?vue&type=template&id=188f43d9&scoped=true"
import script from "./company-notifications.vue?vue&type=script&lang=js"
export * from "./company-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f43d9",
  null
  
)

export default component.exports